<template>
  <div class="size-2 cursor-pointer rounded-50% bg-white-56"></div>
</template>

<script setup></script>

<style lang="scss" scoped>
.active {
  @apply bg-white-100;
}
</style>
